import { Grid2, IconButton, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import HomeCards from "Components/Home/HomeCards";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import EnrolledBackground from "Assets/Backgrounds/enrolled-background.svg";
import Courses from "Components/Home/Courses";
import PendingActions from "Components/Home/PendingActions";
import Practice from "Components/Home/Practice";
import Surprice from "Components/Home/Surprice";
import DiscussionHub from "Components/Home/DiscussionHub";
import Modal from "Components/Common/Modal";
import AccountDetails from "Components/Settings/AccountDetails";
import AcademicJobProfile from "Components/Settings/AcademicJobProfile";
import { useSelector } from "react-redux";


const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "& .timeWarning": {
    background: theme.palette.yellow.main,
    borderRadius: "8px",
    padding: "10px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& .congratsMessage": {
    background: theme.palette.background.blueLight,
    border: `1px solid ${theme.palette.border.blueLight}`,
    borderRadius: "8px",
    padding: "10px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .left": {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
    },
    "& .enrolledBadge": {
      marginRight: "auto",
      marginLeft: "15px",
      backgroundImage: `url(${EnrolledBackground})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      width: "150px",
      height: "40px",
      backgroundSize: "contain",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
});

const HomePage = () => {
  const [selectedTab, setSelectedTab] = useState("");

  const { Profile, isLoading, Translation } = useSelector((state) => ({
    Profile: state.Profile.profile,
    isLoading: state.Profile.loading,
    Translation: state.Translation.translation?.Dashboard || {},
  }));

  useEffect(() => {
    const isProfileLoaded = !isLoading && Object.keys(Profile).length > 0;

    if (isProfileLoaded && !Profile?.Pincode) {
      setSelectedTab("account_details");
    } else if (isProfileLoaded && !Profile?.GraduationYearID) {
      setSelectedTab("academic");
    }
  }, [Profile, isLoading]);

  return (
    <>
      <Grid2 sx={styles}>
        <HomeCards />
        <Grid2 className="timeWarning">
          <Typography variant="body2">
            The selected Time Zone (GMT +03:00) Riyadh is different from your
            system time. Please check it again
          </Typography>
          <IconButton size="small">
            <PrimaryIcon icon={CloseIcon} height="12px" width="12px" />
          </IconButton>
        </Grid2>
        <Grid2 className="congratsMessage">
          <Grid2 className="left">
            <Typography variant="title" fontWeight={500}>
              Congratulations! You have successfully completed your Master's
              onboarding process !
            </Typography>
            <Typography>
              You have been enrolled for Master’s Degree in Computer Science.
            </Typography>
          </Grid2>
          <div className="enrolledBadge">
            <Typography fontWeight={500} color="white" variant="title">
              ENROLLED
            </Typography>
          </div>
          <IconButton size="small">
            <PrimaryIcon icon={CloseIcon} height="12px" width="12px" />
          </IconButton>
        </Grid2>
        <Courses />
        <PendingActions />
        <Practice />
        <Surprice />
        <DiscussionHub />
      </Grid2>

      <Modal open={selectedTab == "account_details"} setOpen={setSelectedTab} title={Translation?.AddDetails} modalBody={<AccountDetails profileInfo={Profile || {}} setSelectedTab={setSelectedTab} />} />
      <Modal open={selectedTab == "academic"} setOpen={setSelectedTab} title={Translation?.AddDetails} modalBody={<AcademicJobProfile profileInfo={Profile || {}} setSelectedTab={setSelectedTab} />} />
    </>
  );
};

export default HomePage;
